import AppRecord from './AppRecord.js'

class MailGroupUser extends AppRecord {
}
export default MailGroupUser
